export default __webpack_public_path__ + "static/media/Research-page-header-1.be4017f8.png";